import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section address">
          <h4>Address</h4>
          <p>
            <p>365, Pioneer Drive,</p>
            <p>Unit 16</p>
            <p>Kitchener, Ontario N2P2A6, Canada</p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p>4370 Steeles Ave W, </p>
            <p>Unit 205</p>
            <p>Woodbridge, ON L4L 4Y4, Canada</p>
          </p>
        </div>
        <div className="footer-section phone-numbers">
          <h4>Phone numbers</h4>
          {/* <p>Toll Free<br/>  <span> 1888-606-0028</span></p> */}
          <p>
            Platform Services
            <br /> <span>+1 (519) 804-6991</span>
            <br /> <span>2265015566</span>
          </p>
          <p>
            Email
            <br />
            <span>info@Ananametchnologies.ca</span>
          </p>
        </div>
        <div className="footer-section about">
          <h4>About</h4>
          <p>
            We are proud of the fact that our entire business was a bootstrapped
            startup that has evolved into an A+ rated multinational enterprise.
          </p>
        </div>
        <div className="footer-section social-media">
          <a href="#" className="social-icon facebook" id="facebook">
            Facebook
          </a>
          <a href="#" className="social-icon twitter">
            Twitter
          </a>
          <a href="#" className="social-icon linkedin">
            LinkedIn
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>©2025 Ananam Technologies</p>
      </div>
    </footer>
  );
};

export default Footer;
